import React from 'react';
import { Outlet } from 'react-router-dom';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
const awesomeProps = {
    type: ComponentType.BEHAVIOR,
};
const RouteOutlet = AwesomeComponent(awesomeProps)(function RouteOutlet() {
    return React.createElement(Outlet, null);
});
export { RouteOutlet, };
//# sourceMappingURL=route-outlet.js.map